import { apiService } from './api.service';
import axios from 'axios';

class LogService {
    async searchLogs(dbName, params) {
        return await apiService.post(`/logs/${dbName}/search`, params);
    }

    async getStats(dbName, params) {
        // Non includiamo il database nei parametri ma solo nell'URL
        return await apiService.post(`/logs/${dbName}/stats`, params);
    }

    async exportToCSV(database, params) {
        return await apiService.post(`/logs/${database}/stats?export=csv`, params);
    }

    async getCollections(dbName) {
        return await apiService.get(`/logs/${dbName}/collections`);
    }

    async getDatabases() {
        return await apiService.get('/databases');
    }

    async deleteLogs(database, params) {
        return await apiService.post(`/logs/${database}/delete`, params);
    }

    async getImeiStats(dbName, collection) {
        try {
            const response = await axios.get(`${this.baseUrl}/stats/imei/${dbName}/${collection}`);
            return {
                success: true,
                data: response.data
            };
        } catch (error) {
            console.error('Errore nel recupero delle statistiche IMEI:', error);
            return {
                success: false,
                error: error.message
            };
        }
    }
}

export const logService = new LogService(); 